import {createSvgIcon} from '../create-svg-icon';

export const TurnSlightLeftIcon = createSvgIcon(
  <path d="M11.66 6V4H6v5.66h2V7.41l5 5V20h2v-7.58c0-.53-.21-1.04-.59-1.41l-5-5h2.25z" />
, 'TurnSlightLeftOutlined');
